import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { LoginFormProps } from '../../shared/types';
import { useThemeMode } from '../../../../contexts/ThemeProvider';

const LoginMethodSwitcher = ({ authLogic, config }: LoginFormProps) => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';
  
  const { loginMode, changeLoginMode, LOGIN_MODES } = authLogic;
  const loginMethodsConfig = config?.login?.loginMethods || {};
  const primaryColor = config?.theme?.primary || '#002465';

  if (loginMethodsConfig.email?.enabled === false || !loginMethodsConfig.emailWithOtp?.enabled) {
    return null;
  }

  return (
    <Box sx={{ textAlign: 'center', mt: 3 }}>
      <Typography
        variant="body2"
        sx={{
          color: isDark ? 'rgba(255,255,255,0.7)' : '#6b7280',
          mb: 1
        }}
      >
        {loginMode === LOGIN_MODES.EMAIL
          ? 'Prefer to use OTP instead?'
          : 'Prefer to use password instead?'}
      </Typography>
      <Link
        component="button"
        type="button"
        onClick={() => changeLoginMode(
          loginMode === LOGIN_MODES.EMAIL ? LOGIN_MODES.EMAILWITHOTP : LOGIN_MODES.EMAIL
        )}
        sx={{
          color: isDark ? '#ffffff' : primaryColor,
          textDecoration: 'underline',
          fontWeight: 600,
          fontSize: '0.875rem',
          minHeight: { xs: '44px', md: 'auto' },
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: 'transparent',
          border: 'none',
          '&:hover': {
            opacity: 0.8,
            textDecoration: 'underline'
          }
        }}
      >
        {loginMode === LOGIN_MODES.EMAIL 
          ? 'Login with Email OTP' 
          : 'Login with Email Password'}
      </Link>
    </Box>
  );
};

export default LoginMethodSwitcher;